import React, { FC } from "react";

import { Button } from "antd";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

const LinkToLogin: FC = () => {
  const { t } = useTranslation("link-to-login");
  return (
    <Link passHref href="/">
      <Button block type="link" className="mt:2">
        {t("back-to-login")}
      </Button>
    </Link>
  );
};

export default LinkToLogin;
